import React, { useState } from "react";
import { StatusDiv } from "./styles";
import {
  MdOutlineWatchLater,
  MdOutlineClose,
  MdOutlineHdrAuto,
  MdCheckCircleOutline,
  MdOutlineNoteAdd,
} from "react-icons/md";
import { TbUrgent } from "react-icons/tb";

export default function Status({
  status,
  isPayment,
  isAttendant,
  isAssociate,
  style,
  isUrgent,
  isMini,
}) {
  if (isUrgent) {
    return (
      <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
        <TbUrgent color="#FFF" style={{ marginRight: 5 }} />
        <span>Urgente</span>
      </StatusDiv>
    );
  }

  if (isPayment) {
    switch (status) {
      case "pendente": {
        return (
          <StatusDiv isMini={isMini} style={style} color={"#FFBB45"}>
            <span>Pagamento Pendente</span>
          </StatusDiv>
        );
        break;
      }
      case "confirmado": {
        return (
          <StatusDiv isMini={isMini} style={style} color={"#46E961"}>
            <span>Pagamento Confirmado</span>
          </StatusDiv>
        );
        break;
      }
      case "cancelado": {
        return (
          <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
            <span>Pagamento Cancelado</span>
          </StatusDiv>
        );
        break;
      }
      case "expirado": {
        return (
          <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
            <span>Pagamento Expirado</span>
          </StatusDiv>
        );
        break;
      }
      default: {
        return (
          <StatusDiv isMini={isMini} style={style} color={"#9D9D9D"}>
            <span>Outro</span>
          </StatusDiv>
        );
      }
    }
  } else {
    if (isAttendant) {
      switch (status) {
        case "pendente": {
          return (
            <StatusDiv isMini={isMini} style={style} color={"#FFBB45"}>
              <span>Pendente</span>
            </StatusDiv>
          );
          break;
        }
        case "andamento": {
          return (
            <StatusDiv isMini={isMini} style={style} color={"#46ADE9"}>
              <span>Em andamento</span>
            </StatusDiv>
          );
          break;
        }
        case "finalizado": {
          return (
            <StatusDiv isMini={isMini} style={style} color={"#008037"}>
              <span>Finalizado</span>
            </StatusDiv>
          );
          break;
        }
        case "cancelado": {
          return (
            <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
              <span>Cancelado</span>
            </StatusDiv>
          );
          break;
        }
      }
    } else {
      if (isAssociate) {
        switch (status) {
          case "aberto": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46ADE9"}>
                <span>Aguardando Franqueado</span>
              </StatusDiv>
            );
            break;
          }
          case "pendente": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
                <span>Documentação Pendente</span>
              </StatusDiv>
            );
            break;
          }
          case "andamento": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#9D9D9D"}>
                <span>Em andamento</span>
              </StatusDiv>
            );
            break;
          }
          case "finalizado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46E961"}>
                <span>Finalizado</span>
              </StatusDiv>
            );
            break;
          }
        }
      } else {
        switch (status) {
          case "aberto": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46ADE9"}>
                <span>Aguardando Técnico</span>
              </StatusDiv>
            );
            break;
          }
          case "negociacao": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FFBB45"}>
                <span>Negociação</span>
              </StatusDiv>
            );
            break;
          }
          case "aguardando": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46ADE9"}>
                <span>Aguardando</span>
              </StatusDiv>
            );
            break;
          }
          case "confirmado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46E961"}>
                <span>Confirmado</span>
              </StatusDiv>
            );
            break;
          }
          case "andamento": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#9D9D9D"}>
                <span>Em andamento</span>
              </StatusDiv>
            );
            break;
          }
          case "pendente": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
                <span>Documentação Pendente</span>
              </StatusDiv>
            );
            break;
          }
          case "pagamento": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FFBB45"}>
                <span>Aguardando Pagamento</span>
              </StatusDiv>
            );
            break;
          }
          case "alteracao": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FFBB45"}>
                <span>Alteração Solicitada</span>
              </StatusDiv>
            );
            break;
          }
          case "finalizado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46E961"}>
                <span>Finalizado</span>
              </StatusDiv>
            );
            break;
          }
          case "assinado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#46E961"}>
                <span>Assinado</span>
              </StatusDiv>
            );
            break;
          }
          case "cancelado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
                <span>Cancelado</span>
              </StatusDiv>
            );
            break;
          }
          case "recusado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#FF5D5D"}>
                <span>Recusado</span>
              </StatusDiv>
            );
            break;
          }
          case "expirado": {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#9D9D9D"}>
                <span>Expirado</span>
              </StatusDiv>
            );
            break;
          }
          default: {
            return (
              <StatusDiv isMini={isMini} style={style} color={"#9D9D9D"}>
                <span>Outro</span>
              </StatusDiv>
            );
          }
        }
      }
    }
  }
}
